import "./capsule.less";

import { IComponentController, IComponentOptions } from "angular";

import { CAPSULE_SERVICE, CapsuleService } from "./capsule.service";
import { BehaviorSubject } from "rxjs";
import { Description } from "../capsule-manager-guide/capsuleManagerGuide.component";


export const CAPSULE_COMPONENT: string= "capsuleComponent";
class CapsuleController implements IComponentController {

    private isDataAvailable : boolean;
    private isLockScreen: boolean;
    private isDownloadProgress: boolean;
    private isShowHideGuide: boolean;
    private isShowHideModal: boolean;
    private descriptions : Description[];
    static $inject = [CAPSULE_SERVICE];

    constructor(private capsuleService: CapsuleService) {
            this.capsuleService.$initializeCapsule();
            this.capsuleService.isShowHideGuide.subscribe((value) => {
                this.isShowHideGuide = value;
            });
            this.capsuleService.isShowHideModal.subscribe((value) => {
                this.isShowHideModal = value;
            });
            this.capsuleService.isLockScreen.subscribe((value) => {
                    this.isLockScreen = value;
            });
             this.capsuleService.isDataAvailable.subscribe((value) => {
                this.isDataAvailable = value;
             });
             this.capsuleService.isDownloadProgress.subscribe((value) => {
                this.isDownloadProgress = value;
             });

             this.descriptions = [];
             // tslint:disable-next-line:max-line-length
             this.descriptions.push(new Description("Capsules Organizer", "Manage your Capsules: upload new Capsules, create copies, move to different folder, download, rename or delete Capsules in your Cloud Instance"));
             // tslint:disable-next-line:max-line-length
             this.descriptions.push(new Description("Actions", "Upload: Upload singles Capsules or .zip folders for multiple Capsules uploads. \n \n "+
                                                                    // tslint:disable-next-line:max-line-length
                                                                    "Create folder: Create new folders under your path and organize Capsules as desired. \n \n " +
                                                                    // tslint:disable-next-line:max-line-length
                                                                    "Download: Download single Capsules or entire folders to localhost.  \n \n "+
                                                                    "Move: Move Single Capsules or folders.  \n \n "+
                                                                    "Copy: Create a copy of Capsules or folders.  \n \n "+
                                                                    "Rename: Rename Capsules or folders.  \n \n "
             ));
         }
    }
export const capsuleComponent: IComponentOptions = {
    controller: CapsuleController,
    template: require("./capsule.html"),
};



// WEBPACK FOOTER //
// ./app/capsule/capsule.component.ts